import { Button, Col, Form, Input, Select } from 'antd'
import styles from './styles.module.scss'
import { v4 as uuidv4 } from 'uuid'
import { debounce } from 'lodash'
import { removeVietnameseTones } from '../../config-func'
const SearchForm = ({
  fetchData,
  handleSearch,
  setFilters,
  cities,
  districts,
  towns,
  onChangeCity,
  onChangeDistrict
}) => {
  const [form] = Form.useForm()

  const handleReset = debounce(() => {
    setFilters({ currentPage: 1, pageSize: 10, reset: uuidv4() })
    form.resetFields()
    // fetchData()
  }, 300)

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSearch}
      style={{ marginTop: 10 }}
      onValuesChange={(value, allValues) => {
        setFilters((prev) => ({ ...prev, ...allValues }))
      }}
    >
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '16px',
          alignItems: 'center'
        }}
      >
        <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
          <Form.Item label="Chủ đầu tư" name="investor">
            <Input
              placeholder="Nhập tên chủ đầu tư"
              onBlur={(e) => {
                form.setFields([
                  {
                    name: 'investor',
                    value: e.target.value?.trim()
                  }
                ])
              }}
            />
          </Form.Item>
        </div>
        <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
          <Form.Item label="Dự án" name="project_name">
            <Input
              placeholder="Nhập tên dự án"
              onBlur={(e) => {
                form.setFields([
                  {
                    name: 'project_name',
                    value: e.target.value?.trim()
                  }
                ])
              }}
            />
          </Form.Item>
        </div>
        <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
          <Form.Item label="Tỉnh/Thành phố" name="city_code">
            <Select
              style={{ width: '100%' }}
              placeholder={`Chọn Tỉnh/Thành phố`}
              onChange={onChangeCity}
              showSearch={true}
              allowClear={true}
              filterOption={(input, option) => {
                const inputValue = removeVietnameseTones(input).toLowerCase()
                const optionValue = removeVietnameseTones(
                  option?.children || ''
                ).toLowerCase()
                return optionValue.includes(inputValue)
              }}
            >
              {cities.map((item, idx) => (
                <Option key={idx} value={item.value}>
                  {item.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </div>
        <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
          <Form.Item label="Quận huyện" name="district_code">
            <Select
              style={{ width: '100%' }}
              placeholder={`Chọn Quận huyện`}
              onChange={onChangeDistrict}
              showSearch={true}
              allowClear={true}
              filterOption={(input, option) => {
                const inputValue = removeVietnameseTones(input).toLowerCase()
                const optionValue = removeVietnameseTones(
                  option?.children || ''
                ).toLowerCase()
                return optionValue.includes(inputValue)
              }}
            >
              {districts.map((item, idx) => (
                <Option key={idx} value={item.value}>
                  {item.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </div>
        <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
          <Form.Item label="Phường xã" name="town_code">
            <Select
              style={{ width: '100%' }}
              placeholder={`Chọn Phường xã`}
              showSearch={true}
              allowClear={true}
              filterOption={(input, option) => {
                const inputValue = removeVietnameseTones(input).toLowerCase()
                const optionValue = removeVietnameseTones(
                  option?.children || ''
                ).toLowerCase()
                return optionValue.includes(inputValue)
              }}
            >
              {towns.map((item, idx) => (
                <Option key={idx} value={item.value}>
                  {item.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </div>
        <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
          <Form.Item label="Đường phố" name="address">
            <Input
              placeholder="Nhập tên đường phố"
              onBlur={(e) => {
                form.setFields([
                  {
                    name: 'address',
                    value: e.target.value?.trim()
                  }
                ])
              }}
            />
          </Form.Item>
        </div>
        <div
          style={{
            display: 'flex',
            gap: '8px',
            justifyContent: 'flex-end',
            flex: '1 1 200px',
            minWidth: '200px'
          }}
        >
          <Button onClick={handleReset}>Đặt lại</Button>
          <Button type="primary" htmlType="submit" style={{ margin: '0 8px' }}>
            Tìm kiếm
          </Button>
        </div>
      </div>
    </Form>
  )
}

export default SearchForm
